// UI chrome translations (business data — services/prices/contact — comes from the API).
export const LANGS = [
  { code: "fr", label: "FR", name: "Français", dir: "ltr" },
  { code: "he", label: "עברית", name: "עברית", dir: "rtl" },
  { code: "en", label: "EN", name: "English", dir: "ltr" },
];

export const translations = {
  fr: {
    nav: { home: "Accueil", about: "À propos", services: "Prestations", prices: "Tarifs", institute: "L'institut", contact: "Contact", book: "Prendre rendez-vous" },
    hero: {
      brand: "L'Éclat du Regard",
      overline: "Institut de beauté · Netanya",
      title1: "Révélez l'éclat",
      title2: "naturel de votre beauté",
      subtitle: "Soins du visage, beauté du regard, épilations, massages et bien-être à Netanya.",
      mention: "Uniquement sur rendez-vous",
      discover: "Découvrir les soins",
      book: "Prendre rendez-vous sur WhatsApp",
    },
    marquee: "L'Éclat du Regard · Soins premium · Netanya · Bien-être · Beauté du regard ·",
    offer: { badge: "Offre du moment", cta: "Réserver cette offre" },
    about: {
      overline: "À propos",
      title: "Votre bulle de douceur au quotidien",
      body: "Parce que votre temps est précieux, L'Éclat du Regard vous accueille uniquement sur rendez-vous afin de vous garantir un moment de détente personnalisé, sans attente. Découvrez une sélection complète de soins consacrés au visage, au regard, au corps et au bien-être.",
      points: [
        { n: "01", t: "Accueil personnalisé" },
        { n: "02", t: "Uniquement sur rendez-vous" },
        { n: "03", t: "Soins adaptés à vos besoins" },
        { n: "04", t: "Cadre doux et relaxant" },
        { n: "05", t: "Au cœur de Netanya" },
      ],
    },
    services: {
      overline: "Nos prestations",
      title: "Prestations & tarifs",
      subtitle: "Tous nos soins, en toute transparence.",
      all: "Toutes les prestations",
      from: "",
      book: "Réserver",
      quote: "Sur devis",
      quoteBtn: "Demander un devis",
    },
    institute: {
      overline: "L'institut",
      title: "Un écrin doux et lumineux",
      subtitle: "Une ambiance beige, apaisante et raffinée, pensée pour votre bien-être.",
      note: "Photos d'illustration — à remplacer par les photos de l'institut.",
    },
    contact: {
      overline: "Contact",
      title: "Prenons rendez-vous",
      addressLabel: "Adresse",
      phoneLabel: "Téléphone & WhatsApp",
      hoursLabel: "Horaires",
      emailLabel: "Email",
      instagramLabel: "Instagram",
      byAppointment: "Uniquement sur rendez-vous",
      openMaps: "Ouvrir dans Google Maps",
      whatsappBtn: "Écrire sur WhatsApp",
    },
    footer: {
      tagline: "Institut de beauté à Netanya. Soins du visage, beauté du regard, épilations, massages et maquillage permanent.",
      nav: "Navigation",
      contact: "Contact",
      language: "Langue",
      rights: "Tous droits réservés.",
      legal: "Mentions légales",
      privacy: "Politique de confidentialité",
      byAppointment: "Uniquement sur rendez-vous",
    },
    floatingWa: "WhatsApp",
    assistant: {
      name: "Votre conseillère beauté",
      status: "Assistante virtuelle",
      launcher: "Une question ?",
      greeting: "Bonjour et bienvenue chez L'Éclat du Regard ✨ Je suis votre conseillère beauté virtuelle. Je peux vous renseigner sur nos soins, nos tarifs et vous aider à choisir la prestation adaptée à vos envies. Comment puis-je vous aider ?",
      placeholder: "Écrivez votre message…",
      send: "Envoyer",
      restart: "Recommencer",
      whatsapp: "Continuer sur WhatsApp",
      quick: ["Voir les prestations", "Consulter les tarifs", "Quel soin choisir ?", "Prendre rendez-vous", "Adresse et horaires"],
      feedbackQ: "Cette réponse vous a-t-elle aidée ?",
      yes: "Oui",
      no: "Non",
      disclaimer: "Assistante virtuelle — réservation uniquement sur WhatsApp.",
      typing: "écrit",
      close: "Fermer",
      error: "Je rencontre un petit souci de connexion 🌸 Réessayez ou contactez-nous directement sur WhatsApp.",
    },
  },
  he: {
    nav: { home: "בית", about: "אודות", services: "טיפולים", prices: "מחירון", institute: "המכון", contact: "צור קשר", book: "לקביעת תור" },
    hero: {
      brand: "זוהר המבט",
      overline: "מכון יופי · נתניה",
      title1: "גלי את הזוהר",
      title2: "הטבעי שבך",
      subtitle: "טיפולי פנים, טיפוח המבט, הסרת שיער, עיסויים ורגעי רוגע בנתניה.",
      mention: "בתיאום מראש בלבד",
      discover: "לגלות את הטיפולים",
      book: "לקביעת תור ב-WhatsApp",
    },
    marquee: "זוהר המבט · טיפולים פרימיום · נתניה · רוגע · טיפוח המבט ·",
    offer: { badge: "מבצע השבוע", cta: "להזמין את המבצע" },
    about: {
      overline: "אודות",
      title: "בועת הרוגע היומיומית שלך",
      body: "מכיוון שהזמן שלך יקר, זוהר המבט מקבל אתכן בתיאום מראש בלבד כדי להבטיח רגע של רגיעה אישית, ללא המתנה. גלי מגוון שלם של טיפולים המוקדשים לפנים, למבט, לגוף ולרווחה.",
      points: [
        { n: "01", t: "קבלת פנים אישית" },
        { n: "02", t: "בתיאום מראש בלבד" },
        { n: "03", t: "טיפולים מותאמים לצרכייך" },
        { n: "04", t: "סביבה רכה ומרגיעה" },
        { n: "05", t: "בלב נתניה" },
      ],
    },
    services: {
      overline: "הטיפולים שלנו",
      title: "טיפולים ומחירון",
      subtitle: "כל הטיפולים שלנו, בשקיפות מלאה.",
      all: "כל הטיפולים",
      from: "",
      book: "להזמנה",
      quote: "בהצעת מחיר",
      quoteBtn: "לבקשת הצעת מחיר",
    },
    institute: {
      overline: "המכון",
      title: "מרחב רך ומואר",
      subtitle: "אווירה בז', מרגיעה ומעודנת, שנוצרה למען הרווחה שלך.",
      note: "תמונות להמחשה — יש להחליף בתמונות של המכון.",
    },
    contact: {
      overline: "צור קשר",
      title: "נקבע תור",
      addressLabel: "כתובת",
      phoneLabel: "טלפון ו-WhatsApp",
      hoursLabel: "שעות פעילות",
      emailLabel: "אימייל",
      instagramLabel: "אינסטגרם",
      byAppointment: "בתיאום מראש בלבד",
      openMaps: "פתחו ב-Google Maps",
      whatsappBtn: "כתבו לנו ב-WhatsApp",
    },
    footer: {
      tagline: "מכון יופי בנתניה. טיפולי פנים, טיפוח המבט, הסרת שיער, עיסויים ואיפור קבוע.",
      nav: "ניווט",
      contact: "צור קשר",
      language: "שפה",
      rights: "כל הזכויות שמורות.",
      legal: "תנאי שימוש",
      privacy: "מדיניות פרטיות",
      byAppointment: "בתיאום מראש בלבד",
    },
    floatingWa: "WhatsApp",
    assistant: {
      name: "יועצת היופי שלך",
      status: "עוזרת וירטואלית",
      launcher: "יש לך שאלה?",
      greeting: "שלום וברוכה הבאה לזוהר המבט ✨ אני יועצת היופי הווירטואלית שלך. אשמח לעזור לך לקבל מידע על הטיפולים, המחירים ולבחור את הטיפול המתאים לך. כיצד אוכל לעזור?",
      placeholder: "כתבי את ההודעה שלך…",
      send: "שליחה",
      restart: "התחלה מחדש",
      whatsapp: "המשך ב-WhatsApp",
      quick: ["צפייה בטיפולים", "צפייה במחירים", "איזה טיפול מתאים לי?", "קביעת תור", "כתובת ושעות פעילות"],
      feedbackQ: "האם התשובה עזרה לך?",
      yes: "כן",
      no: "לא",
      disclaimer: "עוזרת וירטואלית — קביעת תור ב-WhatsApp בלבד.",
      typing: "מקלידה",
      close: "סגירה",
      error: "יש לי תקלת חיבור קטנה 🌸 נסי שוב או פני אלינו ישירות ב-WhatsApp.",
    },
  },
  en: {
    nav: { home: "Home", about: "About", services: "Services", prices: "Prices", institute: "The institute", contact: "Contact", book: "Book an appointment" },
    hero: {
      brand: "L'Éclat du Regard",
      overline: "Beauty institute · Netanya",
      title1: "Reveal your",
      title2: "natural radiance",
      subtitle: "Facial treatments, eye beauty, waxing, massage and wellness in Netanya.",
      mention: "By appointment only",
      discover: "Discover treatments",
      book: "Book on WhatsApp",
    },
    marquee: "L'Éclat du Regard · Premium treatments · Netanya · Wellness · Eye beauty ·",
    offer: { badge: "Special offer", cta: "Book this offer" },
    about: {
      overline: "About",
      title: "Your daily bubble of softness",
      body: "Because your time is precious, L'Éclat du Regard welcomes you by appointment only to guarantee a personalised moment of relaxation, with no waiting. Discover a complete selection of treatments dedicated to the face, the eyes, the body and well-being.",
      points: [
        { n: "01", t: "Personalised welcome" },
        { n: "02", t: "By appointment only" },
        { n: "03", t: "Treatments tailored to you" },
        { n: "04", t: "Soft, relaxing setting" },
        { n: "05", t: "In the heart of Netanya" },
      ],
    },
    services: {
      overline: "Our services",
      title: "Services & prices",
      subtitle: "All our treatments, with full transparency.",
      all: "All services",
      from: "",
      book: "Book",
      quote: "On request",
      quoteBtn: "Request a quote",
    },
    institute: {
      overline: "The institute",
      title: "A soft, luminous cocoon",
      subtitle: "A beige, soothing and refined atmosphere, designed for your well-being.",
      note: "Illustrative photos — to be replaced with the institute's own photos.",
    },
    contact: {
      overline: "Contact",
      title: "Let's book your visit",
      addressLabel: "Address",
      phoneLabel: "Phone & WhatsApp",
      hoursLabel: "Opening hours",
      emailLabel: "Email",
      instagramLabel: "Instagram",
      byAppointment: "By appointment only",
      openMaps: "Open in Google Maps",
      whatsappBtn: "Message on WhatsApp",
    },
    footer: {
      tagline: "Beauty institute in Netanya. Facial treatments, eye beauty, waxing, massage and permanent makeup.",
      nav: "Navigation",
      contact: "Contact",
      language: "Language",
      rights: "All rights reserved.",
      legal: "Legal notice",
      privacy: "Privacy policy",
      byAppointment: "By appointment only",
    },
    floatingWa: "WhatsApp",
    assistant: {
      name: "Your beauty advisor",
      status: "Virtual assistant",
      launcher: "Need help?",
      greeting: "Hello and welcome to L'Éclat du Regard ✨ I'm your virtual beauty advisor. I can tell you about our treatments and prices and help you find the service that best suits your needs. How can I help you?",
      placeholder: "Type your message…",
      send: "Send",
      restart: "Restart",
      whatsapp: "Continue on WhatsApp",
      quick: ["View treatments", "View prices", "Which treatment should I choose?", "Book an appointment", "Address and opening hours"],
      feedbackQ: "Was this answer helpful?",
      yes: "Yes",
      no: "No",
      disclaimer: "Virtual assistant — booking on WhatsApp only.",
      typing: "typing",
      close: "Close",
      error: "I'm having a small connection issue 🌸 Please try again or contact us directly on WhatsApp.",
    },
  },
};
